<template>
    <div class="order-step-2__col order-step-2__col-2">
        <div class="order-step-2__col-2-header">
            <h3 class="order-step-2__col-2-heading">Unser Appetit</h3>
            <a
                href="#"
                class="order-step-2__col-2-link"
                @click.prevent="toggleInfoModalVisible(`
                    <div class='text-container'>
                        <h3>Was bedeuten die Mengenangaben Chasperli, Öpfelchasper und Superchasper?</h3>
                        <p>Unsere Mengenangaben stützen sich auf die Empfehlungen der Schweizerischen Gesellschaft für Ernährung. So sollte eine erwachsene Person täglich 5 Portionen Früchte und Gemüse in verschiedenen Farben zu sich nehmen, wobei 1 Portion rund 120 g entspricht. Pro Woche ist dies eine Gesamtmenge von 4.2 kg Gemüse und Früchte pro Person.
                            <br/><br/>
                            Das Abo «Bio fürs Büro» kann somit folgenden Bedarf an Früchten und/oder Gemüse decken:
                            <br/><br/>
                            Chasperli: 400 g pro Person und Woche (ca. 3 Portionen)<br/>
                            Öpfelchasper: 600 g pro Person und Woche (ca. 5 Portionen)<br/>
                            Superchasper: 800 g pro Person und Woche (ca. 7 Portionen)
                        </p>
                    </div>`)">
                Was bedeutet das?
            </a>
        </div>
        <div class="appetite-options">
            <label
                v-for="(a, index) in appetites"
                :key="a.id"
                :class="['appetite-options__label', `appetite-options__label-${index + 1}`, activeAppetite === a.name ? 'appetite-options__label--active' : '']"
            >
                <input
                    :value="a.name"
                    class="appetite-options__input"
                    name="appetite"
                    type="radio"
                    @change="updateAppetite(a.name, mode)"
                >
                <span class="sr-only">{{ a.name }}</span>
            </label>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState({
            mode: state => state.mode,
            activeAppetite: state => state.appetite,
            appetites: state => state.subscriptionType && state.orderable.product_groups
                .find(s => s.id === state.subscriptionType).appetites,
        }),
    },
    methods: {
        updateAppetite(name, mode) {
            this.$store.dispatch('updateAppetite', { name, mode });
        },
        toggleInfoModalVisible(content) {
            this.$store.commit('toggleInfoModalVisible', content);
        },
    },
};
</script>



// WEBPACK FOOTER //
// Appetite.vue?04f8d9cc